// src/components/store/sections/newsletter/NewsletterV72MinimalinlineCoralFlame.tsx
"use client";

import React from "react";
import DynamicNewsletterVariant from "./DynamicNewsletterVariant";

export default function NewsletterV72MinimalinlineCoralFlame(props: any) {
  return (
    <DynamicNewsletterVariant
      variantNumber={72}
      archKey="minimal_inline"
      archLabel="Minimalist Inline Strip"
      palName="CoralFlame"
      grad="from-orange-500 via-rose-500 to-pink-700"
      lightBg="bg-orange-50"
      textCol="text-orange-700"
      borderCol="border-orange-200"
      btnCls="bg-rose-600 hover:bg-rose-700"
      hexCol="#f97316"
      {...props}
    />
  );
}
